/**
 * Ordena conversaciones: primero las que tienen el último mensaje del otro
 * (pendientes de respuesta del usuario actual), luego por fecha más reciente.
 * @param {Array} list - Lista de conversaciones (cada una con messages[0] = último mensaje)
 * @param {number} [currentUserId] - ID del usuario actual; si se pasa, se priorizan pendientes
 */
const sortConversations = (list, currentUserId) => {
  return [...list].sort((a, b) => {
    const aLast = a.messages && a.messages[0];
    const bLast = b.messages && b.messages[0];
    const aPending = currentUserId != null && aLast?.user?.id != null && Number(aLast.user.id) !== Number(currentUserId);
    const bPending = currentUserId != null && bLast?.user?.id != null && Number(bLast.user.id) !== Number(currentUserId);
    if (aPending && !bPending) return -1;
    if (!aPending && bPending) return 1;
    return new Date(bLast?.createdAt || 0) - new Date(aLast?.createdAt || 0);
  });
};

export default sortConversations;
